
import Vue from "vue"
import Component from "vue-class-component"
import {QBtn} from "quasar"
import {Prop} from "vue-property-decorator"

@Component({components: {QBtn}})
export default class CloseButton extends Vue {
  @Prop({default: null})
  label: string

  @Prop({default: false})
  disable: boolean

  /*
  <q-btn
            v-close-popup
            dense
            no-caps
            color="primary"
            :disable="isItemDisabled"
            @click="persistItem">
            Save
          </q-btn>
   */
}
